"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideDownContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _IconButton = require("../buttons/IconButton");

var _Transition = require("../animate/Transition");

var _iconConst = require("../icons/iconConst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Render prop component with control for displaying and hiding content.
 */
var SlideDownContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SlideDownContent, _React$Component);

  function SlideDownContent(props) {
    var _this;

    _classCallCheck(this, SlideDownContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SlideDownContent).call(this, props));
    _this.handleOnClick = _this.handleOnClick.bind(_assertThisInitialized(_this));
    var closedChevron = _this.props.pointRight ? _iconConst.CHEVRON_RIGHT : _iconConst.CHEVRON_LEFT;
    _this.state = {
      closedChevron: closedChevron,
      icon: _this.props.startOpen ? _iconConst.CHEVRON_DOWN : closedChevron
    };
    return _this;
  }

  _createClass(SlideDownContent, [{
    key: "handleOnClick",
    value: function handleOnClick() {
      var nextChevron = this.state.icon === _iconConst.CHEVRON_DOWN ? this.state.closedChevron : _iconConst.CHEVRON_DOWN;
      this.setState({
        icon: nextChevron
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          label = _this$props.label,
          cashbotName = _this$props.cashbotName,
          render = _this$props.render;
      var baseClassName = 'slide-down-content';
      var CssClassBase = (0, _dedupe.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "__top-border"), this.props.topBorder), _defineProperty(_classNames, "".concat(baseClassName, "__bottom-border"), this.props.bottomBorder), _classNames));
      var cssClassHdr = (0, _dedupe.default)(baseClassName, "".concat(baseClassName, "__header"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(baseClassName, "__header--right"), this.state.closedChevron === _iconConst.CHEVRON_RIGHT), _defineProperty(_classNames2, "".concat(baseClassName, "__header--left"), this.state.closedChevron === _iconConst.CHEVRON_LEFT), _classNames2));
      var cssClassBtn = (0, _dedupe.default)(baseClassName, "".concat(baseClassName, "__chevron"));
      var cssClassLabel = (0, _dedupe.default)(baseClassName, "".concat(baseClassName, "__label"));
      return _react.default.createElement("div", {
        className: CssClassBase
      }, _react.default.createElement("div", {
        className: cssClassHdr
      }, _react.default.createElement(_IconButton.IconButton, {
        cashbotName: cashbotName,
        onClick: this.handleOnClick,
        ariaLabel: label,
        cssClass: cssClassBtn,
        icon: this.state.icon
      }), _react.default.createElement("div", {
        className: cssClassLabel
      }, label)), this.state.icon === _iconConst.CHEVRON_DOWN && _react.default.createElement(_Transition.Transition, {
        config: _Transition.slideDownConfig
      }, _react.default.createElement("div", {
        key: (0, _uuid.v4)(),
        className: "".concat(baseClassName, "__display")
      }, render())));
    }
  }]);

  return SlideDownContent;
}(_react.default.Component);

exports.SlideDownContent = SlideDownContent;
SlideDownContent.defaultProps = {
  startOpen: false,
  pointRight: false,
  cashbotName: 'slide-down-content-btn',
  topBorder: true,
  bottomBorder: false
};
SlideDownContent.propTypes = {
  render: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  startOpen: _propTypes.default.bool,
  pointRight: _propTypes.default.bool,
  cashbotName: _propTypes.default.string,
  topBorder: _propTypes.default.bool,
  bottomBorder: _propTypes.default.bool
};